import type { Logger } from "@expert/logging";
import type { TMessageData } from "@simplrsupport/headless-chat-web";
import { MESSAGE_DATA_TYPES, SimplrChatSDK } from "@simplrsupport/headless-chat-web";
import type { AnalyticsInfo, SessionMetadata } from "../store";
import type { GuideSelectionObject } from "./types";

export function navigateBack({ restartFlow = false }: { restartFlow?: boolean }) {
    if (restartFlow) {
        void SimplrChatSDK.navigateBack({ startOver: true });
    } else {
        void SimplrChatSDK.navigateBack();
    }
}

/* 
   Calling startSession for a sessionId with an existing session will not
   restart the session, it will pick back up wherever the session left off.
   This allows for managing multiple sessions at a given time.
*/
export function startSimplrSession({ metadata, sessionId }: { metadata?: SessionMetadata; sessionId: string }) {
    void SimplrChatSDK.startSession({ externalTicketId: sessionId, moreTicketInfo: metadata });
}

export function triggerNextStep(option: string, logger: Logger) {
    const messageData = {
        type: MESSAGE_DATA_TYPES.TEXT,
        text: option,
    } as TMessageData;

    logger.info(`Solve Guide | calling triggerNextStep with: ${option}`);
    void SimplrChatSDK.sendMessage(messageData);
}

export function automaticallySelectGuideIfNeeded(
    analyticsInfo: AnalyticsInfo,
    availableGuides: GuideSelectionObject[],
    guide: string,
    logger: Logger,
    setCurrentGuideName: (name: string) => void,
) {
    if (
        availableGuides.map((guide) => guide.title)?.includes(guide) &&
        analyticsInfo.currentStepId === "GuideSelection"
    ) {
        triggerNextStep(guide, logger);
        setCurrentGuideName(guide);
        logger.info(`Solve Guide | Selected flow automatically: ${guide}`);
    } else {
        logger.info({ availableGuides, ...analyticsInfo }, `Solve Guide | NOT selecting flow automatically: ${guide}`);
    }
}
